import { Config } from './Config'
import config from '../../temp/config'
import { injectable } from 'inversify'
@injectable()
export class StaticConfigProvider {
  getConfig(): Config {
    return config as unknown as Config
  }
}

//  DO NOT DELETE - used by DW
